import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import {
  createMeterUploadRow,
  type RowInput,
} from "@services/bulkMeterUpload";

export const useCreateMeterUploadRow = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ meterUploadId, input }: { meterUploadId: string; input: RowInput }) =>
      createMeterUploadRow(meterUploadId, input),
    {
      ...options,
      onSuccess: (row, vars) => {
        queryClient.invalidateQueries({
          queryKey: ["meterUpload", vars.meterUploadId],
        });
        if (isFunction(onSuccess)) onSuccess(row, vars);
      },
    },
  );
};
